
import { getUserRole } from "@/service/userrole.service";
import { getStation } from "@/service/station.service";
import { postUser, saveAvailableRoutes } from "@/service/user.service";
import { defineComponent } from "@vue/runtime-core";
import { User } from "@/types/user.type";
import { UserRole } from "@/types/userrole.type";
import { ElForm, ElMessage } from "element-plus";
import { getSamplingPointNames } from "@/service/samplingpoint.service";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { Station } from "@/types/station.type";
import ComponentNewMenuItem from "@/components/ModalNewMenuItem.component.vue";
import { MenuItem } from "@/types/menuItem.type";

export default defineComponent({
  components: {
    ComponentNewMenuItem,
  },
  props: {
    id: {
      type: Number,
      required: false,
    },
    active: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      error: "",
      userForm: {} as User,
      userRole: [] as UserRole[],
      permissions: [] as number[],
      rolesString: [
        "U.C.Visualizador",
        "U.C.Configurador",
        "U.C.Agente de Campo",
        "U.E.Visualizador",
        "U.E.Configurador",
        "U.E.Mantenimiento",
      ],
      samplingpoints: [] as SamplingPoint[],
      samNumbers: [] as number[],
      stationsNumber: [] as number[],
      stations: [] as Station[],
      passwordRepeat: "",
      visualiceModalMenus: false as boolean,
      menuItems: [] as MenuItem[],
      menuItemsSelect: [] as MenuItem[],
      availableRoutesList: [
        { label: "Support - Home", value: "/support" },
        { label: "Support - Sampling Points", value: "/support/samplingPoints" },
        { label: "Support - Alerts", value: "/support/alerts" },
        { label: "Support - Import", value: "/support/import" },
        { label: "Support - Report", value: "/support/report" },
        { label: "Stations - Home", value: "/stations" },
        { label: "Stations - Stations", value: "/stations/stations" },
        { label: "Stations - Alerts", value: "/stations/alerts" },
        { label: "Stations - Sampling Points", value: "/stations/samplingPoints" },
        { label: "Stations - Graph", value: "/stations/graph" },
        { label: "Stations - Report", value: "/stations/report" },
        { label: "Process-Tracking - Home", value: "/process-tracking" },
        { label: "Process-Tracking - Lista puntos", value: "/process-tracking/samplingpoints" },
        { label: "Process-Tracking - Subir datos", value: "/process-tracking/upload" },
        { label: "Process-Tracking - Cargar datos", value: "/process-tracking/trainingdata" },
        {
          label: "Process-Tracking - Descarga datos",
          value: "/process-tracking/downloadTrainingData",
        },
        { label: "Issue-Monitoring - Home", value: "/issue-monitoring" },
        { label: "Issue-Monitoring - Lista puntos", value: "/issue-monitoring/samplingpoints" },
        { label: "Issue-Monitoring- Histórico", value: "/issue-monitoring/list" },
      ],
      availableRoutes: [] as string[],

      aquacorpMemberOption: [
        { label: "Miembro", value: "Member" },
        { label: "No miembro", value: "No Member" },
      ],
      aquacorpMember: [] as string[],

      rules: {
        name: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        userName: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        passwordrepeat: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        dateregistration: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        timeregistration: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        permissions: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: "blur",
          },
        ],
        // aquacorpMember: [
        //   {
        //     zrequired: true,
        //     message: this.$t("error.required"),
        //     trigger: "blur",
        //   },
        // ],
        // stations: [
        //   {
        //     required: true,
        //     message: this.$t("error.required"),
        //     trigger: "blur",
        //   },
        // ],
        // samplingpoints: [
        //   {
        //     required: true,
        //     message: this.$t("error.required"),
        //     trigger: "blur",
        //   },
        // ],
      },
    };
  },
  methods: {
    // open() {
    //   this.visualiceModalMenus = true;
    // },
    close() {
      this.visualiceModalMenus = false;
    },
    async configMenuItems() {
      this.visualiceModalMenus = true;
      let menuItemsSelect = await (
        this.$refs["menuDialog"] as InstanceType<typeof ComponentNewMenuItem>
      ).saveItemSelect();
      this.userForm.menuItems = menuItemsSelect;
      this.visualiceModalMenus = false;
    },

    async doSave(): Promise<User> {
      // Save roles in userForm
      this.userForm.permissions = [];
      let isAdmin = false;
      for (let permission of this.permissions) {
        this.userRole;
        this.userForm.permissions.push(this.userRole[permission - 1]);
        if (this.userRole[permission - 1].id === 7) {
          isAdmin = true;
        }
      }

      this.removeItems();

      // Save samplingPoint in userForm
      // TODO optimize
      this.userForm.samplingPoints = [];
      for (let sampPoint of this.samplingpoints) {
        if (sampPoint.id && this.samNumbers.includes(sampPoint.id)) {
          this.userForm.samplingPoints.push(sampPoint);
        }
      }

      // Save stations in useForm
      // TODO optimize
      this.userForm.stations = [];
      for (let station of this.stations) {
        if (station.id && this.stationsNumber.includes(station.id)) {
          this.userForm.stations.push(station);
        }
      }

      if (isAdmin) {
        this.userForm.permissions.splice(0, this.userForm.permissions.length);
        this.userForm.permissions.push(this.userRole[6]);
        this.userForm.samplingPoints.splice(0, this.userForm.samplingPoints.length);
        this.userForm.stations.splice(0, this.userForm.stations.length);
      }

      this.error = "";
      // - form validation
      let valid;
      try {
        valid = await (this.$refs["form"] as InstanceType<typeof ElForm>).validate();
      } catch (error) {
        valid = false;
      }
      if (!valid) {
        throw new Error("validation");
      }
      // - call service
      try {
        let user;
        user = await postUser(this.userForm);
        try {
          if (user.id !== undefined) {
            const payload = {
              userId: user.id,
              availableRoutes: this.availableRoutes,
            };

            await saveAvailableRoutes(payload);
          } else {
            // eslint-disable-next-line no-console
            console.log("Error: userId no está definido");
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log("Error:", error);
        }
        //    - notify
        return user;
      } catch (error) {
        this.error = "error.any";
        ElMessage.error(this.$t("error.any"));
        throw new Error("save");
      }
    },
    /**
     * Delete unselected items according to roles
     */
    removeItems() {
      if (
        !this.permissions.includes(1) &&
        !this.permissions.includes(2) &&
        !this.permissions.includes(3) &&
        !this.permissions.includes(8)
      ) {
        this.samNumbers = [];
      } else if (
        !this.permissions.includes(4) &&
        !this.permissions.includes(5) &&
        !this.permissions.includes(6)
      ) {
        this.stationsNumber = [];
      }
    },
    toggleSelectAll() {
      if (this.availableRoutes.length === this.availableRoutesList.length) {
        this.availableRoutes = [];
      } else {
        this.availableRoutes = this.availableRoutesList.map((route) => route.value);
      }
    },
  },
  async mounted() {
    this.userRole = await getUserRole();
    this.samplingpoints = await getSamplingPointNames();
    this.stations = await getStation();
  },
});
